import { Box, Stack, Typography, type SxProps } from '@mui/material';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  /** Title text. Accepts any ReactNode so icons / tooltips can sit beside it. */
  title: ReactNode;
  description?: string;
  actions?: ReactNode;
  sx?: SxProps;
}

export function PageHeader({ title, description, actions, sx }: PageHeaderProps) {
  return (
    <Box sx={{ mb: 3, ...sx }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Box>
          <Typography variant="h5" fontWeight={600}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {description}
            </Typography>
          )}
        </Box>
        {actions && (
          <Stack direction="row" spacing={1}>
            {actions}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
